import { isBoolean } from 'lodash';

export type DigdashParams = {
  page?: string | null;
  hideBanner?: boolean | null;
  hideFilters?: boolean | null;
};

export const buildIFrameDigdashLink = (
  rawLink: string,
  digdashToken: { user: string; newAuthTokenAs: string } | undefined | null,
  digdashParams?: DigdashParams | null,
) => {
  if (!rawLink) {
    return rawLink;
  }

  const hashIndex = rawLink.indexOf('#');
  const linkWithoutHash = hashIndex >= 0 ? rawLink.slice(0, hashIndex) : rawLink;
  const hash = hashIndex >= 0 ? rawLink.slice(hashIndex) : '';

  const queryIndex = linkWithoutHash.indexOf('?');
  const baseLink = queryIndex >= 0 ? linkWithoutHash.slice(0, queryIndex) : linkWithoutHash;
  const queryString = queryIndex >= 0 ? linkWithoutHash.slice(queryIndex + 1) : '';

  const searchParams = new URLSearchParams(queryString);

  if (isBoolean(digdashParams?.hideBanner)) {
    searchParams.delete('hidBanner');
    searchParams.set('hideBanner', String(digdashParams?.hideBanner));
  }
  if (isBoolean(digdashParams?.hideFilters)) {
    searchParams.delete('hidFilters');
    searchParams.set('hideFilters', String(digdashParams?.hideFilters));
  }
  if (digdashParams?.page) {
    searchParams.delete('page');
    searchParams.set('page', digdashParams.page);
  }
  if (digdashToken) {
    searchParams.delete('authToken');
    searchParams.delete('user');
    searchParams.set('authToken', digdashToken.newAuthTokenAs);
    searchParams.set('user', digdashToken.user);
  }

  const nextQueryString = searchParams.toString();

  return nextQueryString ? `${baseLink}?${nextQueryString}${hash}` : `${baseLink}${hash}`;
};

export const isDigdashLink = (link: string) => {
  return link.includes('-dd-');
};
